import {Box, Grid} from '@mui/material';
import React from 'react';
import {Panel} from '../../components/Panel/Panel';
import {OneViewModelTypesEnum} from '../../schema-types/globalTypes';
import AutoField, {ActionType} from '../../components/AutoForm/AutoFieldNew';
import {AutoFormDebug} from '../../components/AutoForm/AutoFormNew';

export const TestForm: React.FC = () => {
  return (
    <>
      <Panel title="Example form">
        <Box padding={4}>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  <AutoField
                    field={{
                      type: ActionType.boolean,
                      id: 'booleanField',
                      label: 'boolean field',
                      noValue: false,
                      yesValue: true,
                    }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <AutoField
                    field={{
                      type: ActionType.boolean,
                      noValue: false,
                      yesValue: true,
                      id: 'booleanFieldDisabled',
                      label: 'boolean field disabled',
                      disabled: true,
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <AutoField
                    field={{
                      type: ActionType.boolean,
                      noValue: false,
                      initialValue: true,
                      yesValue: true,
                      id: 'booleanFieldStartChecked',
                      label: 'boolean field start checked',
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <AutoField
                    field={{
                      type: ActionType.boolean,
                      noValue: false,
                      yesValue: true,
                      id: 'booleanFieldDisabledChecked',
                      label: 'boolean field disabled checked',
                      disabled: true,
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <AutoField
                    field={{type: ActionType.text, id: 'textField', label: 'text field'}}
                  />
                </Grid>
                <Grid item xs={6}>
                  <AutoField
                    field={{
                      type: ActionType.text,
                      id: 'textFieldDisabled',
                      label: 'text field disabled',
                      disabled: true,
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <AutoField
                    field={{
                      type: ActionType.text,
                      currency: true,
                      decimals: 2,
                      id: 'moneyField',
                      label: 'money field',
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <AutoField
                    field={{
                      type: ActionType.text,
                      currency: true,
                      decimals: 2,
                      id: 'moneyFieldDisabled',
                      label: 'money field disabled',
                      disabled: true,
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <AutoField
                    field={{
                      type: ActionType.text,
                      percent: true,
                      decimals: 2,
                      id: 'percentageField',
                      label: 'percentage field',
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <AutoField
                    field={{
                      type: ActionType.text,
                      percent: true,
                      decimals: 2,
                      id: 'percentageFieldDisabled',
                      label: 'percentage field disabled',
                      disabled: true,
                    }}
                  />
                </Grid>

                <Grid item xs={4}>
                  <AutoField
                    field={{
                      type: ActionType.radioGroup,
                      id: 'radioGroupFieldBooleans',
                      label: 'radio group field with booleans',
                      options: [
                        {label: 'yes', value: true},
                        {label: 'no', value: false},
                      ],
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <AutoField
                    field={{
                      type: ActionType.radioGroup,
                      id: 'radioGroupField',
                      label: 'radio group field',
                      options: [
                        {label: 'yes', value: 'yes'},
                        {label: 'no', value: 'no'},
                      ],
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <AutoField
                    field={{
                      type: ActionType.radioGroup,
                      id: 'radioGroupFieldDisabled',
                      label: 'radio group field disabled',
                      options: [
                        {label: 'yes', value: 'yes'},
                        {label: 'no', value: 'no'},
                      ],
                      disabled: true,
                    }}
                  />
                </Grid>
                <Grid item xs={4}>
                  <AutoField
                    field={{
                      type: ActionType.radioGroup,
                      id: 'radioGroupFieldPartiallyDisabled',
                      label: 'radio group field partially disabled',
                      options: [
                        {label: 'yes', value: 'yes'},
                        {label: 'no disabled', value: 'no disabled', disabled: true},
                      ],
                    }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <AutoField
                    field={{
                      type: ActionType.boolean,
                      noValue: false,
                      yesValue: true,
                      id: 'booleanField',
                      label: 'boolean field',
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <AutoField
                    field={{
                      type: ActionType.boolean,
                      noValue: false,
                      yesValue: true,
                      id: 'booleanFieldDisabled',
                      label: 'boolean field disabled',
                      disabled: true,
                    }}
                  />
                </Grid>

                <Grid item xs={6}>
                  <AutoField
                    field={{
                      type: ActionType.checkboxGroup,
                      options: [],
                      id: 'checkboxGroupField',
                      label: 'checkboxGroup field',
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <AutoField
                    field={{
                      type: ActionType.checkboxGroup,
                      options: [],
                      id: 'checkboxGroupFieldDisabled',
                      label: 'checkboxGroup field disabled',
                      disabled: true,
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <AutoField
                    field={{
                      type: ActionType.select,
                      id: 'selectField',
                      label: 'select field',
                      options: Object.keys(OneViewModelTypesEnum).map((v) => ({
                        label: v,
                        value: v,
                      })),
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <AutoField
                    field={{
                      type: ActionType.select,
                      id: 'selectFieldDisabled',
                      label: 'select field disabled',
                      disabled: true,
                      options: Object.keys(OneViewModelTypesEnum).map((v) => ({
                        label: v,
                        value: v,
                      })),
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <AutoField
                    field={{
                      type: ActionType.text,
                      id: 'textarea',
                      label: 'textarea',
                      minRows: 4,
                      multiline: true,
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <AutoField
                    field={{
                      type: ActionType.text,
                      id: 'textarea',
                      label: 'textarea',
                      minRows: 4,
                      multiline: true,
                      disabled: true,
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={6}>
              <AutoFormDebug />
            </Grid>
          </Grid>
        </Box>
      </Panel>
      <Box mt={4} />
    </>
  );
};
